// extracted by mini-css-extract-plugin
export default {"tipsWrapper":"jbwUhz","tipsWrapperScrollBarContainer":"NMpiqv","tipsWrapperItemContainer":"ErI7Se","tipsSeparator":"yEwuLC"};